<template>
<div class="systemCropper padding-20">
    <el-dialog title="素材图库" :visible.sync="dialogVisible">
        <div class="select-box">
            选择相册：<el-select v-model="imageGroupId" placeholder="请选择" @change="setImageGroup">
                <el-option v-for="item in options" :key="item.innerid" :label="item.catename" :value="item.innerid"> </el-option>
            </el-select>
        </div>
        <scroll ref="scroll" :uploadType="uploadType" @saveFile="_saveFile"></scroll>
        <cropper :cropperOption="cropperOption" ref="cropper" @getCanvas="getCanvas" v-if="imgBase"></cropper>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import Cropper from 'base/cropper/cropper'
import {getUploadParam, qiniuFormUpload} from 'api/api'
import $ from 'jquery'
import Scroll from 'base/scrollBox/scroll'
import {getColList} from 'api/materialMgtApi'
import {mapGetters, mapActions} from 'vuex'
import {data64toFile} from 'common/js/tools'
export default {
    name: 'systemCropper',
    data() {
        return {
            dialogVisible: false,
            imgBase: '',
            uploadSetting: {
                localvurl: '', // 本地访问图片地址
                uploadauth: '', // 授权信息
                uploadfilekey: '', // 文件保存名字
                uploadurl: '' // 上传文件地址
            },
            fileInfo: {},
            param: {
                materialtype: 2 // 获取视频分组id/图片分组id // materialtype 1视频 2图片
            },
            fileOtherInfo: {
                type: 'add',
                keyid: '',
                vsource: 1, // 1自己上传 2素材 3系统默认资源
                furl: ''
            },
            options: [],
            imageGroupId: ''
        }
    },
    props: ['cropperOption', 'uploadType'],
    mounted() {
    },
    methods: {
        setImageGroup() {
            this.$refs.scroll.getList((this.$refs.scroll.$el.offsetWidth - 60) / 100, this.imageGroupId)
        },
        _getUploadParam() {
            this.setLoading(true)
            getUploadParam({
                data: Object.assign({}, this.uploadType),
                success: data => {
                    this.uploadSetting = data.data
                    this.fileOtherInfo.furl = this.uploadSetting.localvurl
                    this.setLoading(false)
                    this.uploadFile()
                },
                error: data => {
                    this.$message.error('获取参数错误')
                    this.setLoading(false)
                }
            })
        },
        getCanvas(img) {
            if (img) {
                this.imgBase = img
            }
        },
        _saveFile(file) {
            this.fileInfo = file
            this.imgBase = file.furl
            this.$nextTick(() => {
                this.$refs.cropper.setCanvas(this.imgBase)
            })
        },
        cancel() {
            if (this.imgBase) {
                this.$refs.cropper.cancel()
            }
            this.imageGroupId = ''
            this.imgBase = ''
            this.dialogVisible = false
        },
        submit() {
            if (this.imgBase) {
                if (this.uploadSetting.uploadauth) {
                    this.uploadFile()
                } else {
                    this._getUploadParam()
                }
            } else {
                this.$alert('请选择图片', '提示', {
                    dangerouslyUseHTMLString: true
                })
            }
        },
        openDialog() {
            this.imgBase = ''
            $('.cropper img').attr('src', '')
            this.dialogVisible = true
            this._getColList()
            let _this = this
            this.$nextTick(() => {
                _this.$refs.scroll.getList((_this.$refs.scroll.$el.offsetWidth - 60) / 100, _this.imageGroupId)
            })
        },
        // 获取视频/图片合集
        _getColList() {
            getColList({
                data: Object.assign({}, {hostinfoinnerid: this.user.hostinnerid}, this.param),
                success: data => {
                    this.options = data.data
                },
                error: data => {
                    this.$message.error(data.msg)
                }
            })
        },
        uploadFile() {
            let img = data64toFile(this.imgBase, new Date().getTime())
            let formData = new FormData()
            formData.append('file', img)
            formData.append('key', this.uploadSetting.uploadfilekey)
            formData.append('token', this.uploadSetting.uploadauth)
            qiniuFormUpload({
                url: this.uploadSetting.uploadurl,
                data: formData,
                success: (data) => {
                    this.$emit('setImage', Object.assign({}, data, this.fileOtherInfo))
                    this.cancel()
                },
                error: (data) => {
                    this.$message.error('上传失败，请重新上传')
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        Cropper,
        Scroll
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.systemCropper {
    .el-input__icon{
        line-height: 1;
    }
    .el-dialog{
        width: 800px;
    }
    .select-box{
        @include flexBox(flex-start);
        margin-bottom: 20px;
        .btn {
            display: inline-block;
            line-height: 1;
            white-space: nowrap;
            cursor: pointer;
            text-align: center;
            box-sizing: border-box;
            outline: none;
            margin:0 5px;
            padding: 8px 15px;
            font-size: 14px;
            border-radius: 4px;
            color: $tcolor-gray;
            background: $bgcolor-white;
            border: 1px solid $line;
            transition: all .2s ease;
            text-decoration: none;
            user-select: none;
        }
    }
    .image-small{
        @include flexBox(space-between);
        margin-bottom: 20px;
        .btn{
            width: 30px;
            font-size: 30px;
            font-weight: 600;
        }
        .image-list{
            flex-grow: 1;
            width: 500px;
            height: 60px;
            overflow: hidden;
            margin: auto;
            position: relative;
            .image-list-inner{
                transition: all 1s;
                left: 0;
                position: absolute;
                @include flexBox(flex-start);
                img{
                    box-sizing: border-box;
                    width: 90px;
                    height: 60px;cursor: pointer;
                    padding: 2px;
                }
                img + img{
                    margin-left: 10px;
                }
                img.is-active{
                    border: 1px solid $line;
                }
            }
        }
    }
}
</style>
